var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "blog-main-block" }, [
    _c(
      "div",
      { staticClass: "wrapper" },
      [
        _c("h1", { domProps: { innerHTML: _vm._s(_vm.title) } }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "blog-main-block__container" },
          [
            _c(
              "transition-group",
              { attrs: { name: "fade" } },
              _vm._l(_vm.posts, function(post) {
                return _c(
                  "a",
                  {
                    key: post.url,
                    staticClass: "blog-item",
                    attrs: { href: post.url }
                  },
                  [
                    post.thumbnail != "#"
                      ? _c("span", {
                          staticClass: "blog-item__bg",
                          style: {
                            "background-image": "url(" + post.thumbnail + ")"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "blog-item__text" }, [
                      _c("time", { attrs: { datetime: post.datetime } }, [
                        _vm._v(_vm._s(post.date))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "title" }, [
                        _vm._v(_vm._s(post.title))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "desc" }, [
                        _vm._v(_vm._s(post.description))
                      ])
                    ])
                  ]
                )
              }),
              0
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("transition", { attrs: { name: "fade", duration: 300 } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.posts.length < _vm.total,
                  expression: "posts.length < total"
                }
              ],
              staticClass: "blog-main-block__foot"
            },
            [
              _c(
                "button",
                {
                  staticClass: "button-pill inline",
                  on: {
                    click: function($event) {
                      return _vm.getPosts()
                    }
                  }
                },
                [_vm._v("Загрузить ещё")]
              )
            ]
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }